module.exports = __webpack_public_path__ + "img/rating-b&w (1).7d70084b.svg";